let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fN6FK")).then(() => parcelRequire('1jD7c'));